import { gql } from "@apollo/client";
import { Query } from "@apollo/client/react/components";
import { compose, graphql, ApolloProvider } from "@apollo/client/react/hoc";

import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";
//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//Add School
const GQLAddSchool = gql`
  mutation addSchool(
    $homejunctionschoolid: String
    $schoolname: String
    $schooldistname: String
    $address: String
    $city: String
    $zipcode: String
    $phonenumber: String
    $schoolurl: String
    $schooldisturl: String
    $county: String
    $institutetype: String
    $schooltype: String
    $instructionlevel: String
    $lat: String
    $lang: String
    $schoolgrade: String
    $latlangs: String
    $school_cords: String
    $rating: String
    $rating_num: Float
    $gradelow: String
    $gradehigh: String
  ) {
    createSchool(
      homejunctionschoolid: $homejunctionschoolid
      schoolname: $schoolname
      schooldistname: $schooldistname
      address: $address
      city: $city
      zipcode: $zipcode
      phonenumber: $phonenumber
      schoolurl: $schoolurl
      schooldisturl: $schooldisturl
      county: $county
      institutetype: $institutetype
      schooltype: $schooltype
      instructionlevel: $instructionlevel
      lat: $lat
      lang: $lang
      schoolgrade: $schoolgrade
      latlangs: $latlangs
      school_cords: $school_cords
      rating: $rating
      rating_num: $rating_num
      gradelow: $gradelow
      gradehigh: $gradehigh
    ) {
      success
      message
    }
  }
`;

//Update School
const GQLUpdateSchool = gql`
  mutation updateSchool($id: String!, $name: String) {
    updateSchool(id: $id, name: $name) {
      success
      message
    }
  }
`;

//Delete School
const GQLDeleteSchool = gql`
  mutation deleteSchool($id: String!) {
    DeleteSchool(id: $id) {
      success
      message
    }
  }
`;

//Get All School
const QUERY_getAllSchoolList = gql`
  query getSchool(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
    $zoomLevel: Int
    $device: String
  ) {
    getSchool(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
      zoomLevel: $zoomLevel
      device: $device
    ) {
      id
      homejunctionschoolid
      schoolname
      schooldistname
      address
      city
      zipcode
      phonenumber
      schoolurl
      schooldisturl
      county
      institutetype
      schooltype
      instructionlevel
      lat
      lang
      schoolgrade
      latlangs
      school_cords
      rating
      gradelow
      noofstudent
      studentratio
      greatschoolurl
    }
  }
`;
//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Add Neighbor Function

async function addSchool(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddSchool,

        variables: {
          homejunctionschoolid: adddata.homejunctionschoolid,
          schoolname: adddata.schoolname,
          schooldistname: adddata.schooldistname,
          address: adddata.address,
          city: adddata.city,
          zipcode: adddata.zipcode,
          phonenumber: adddata.phonenumber,
          schoolurl: adddata.schoolurl,
          schooldisturl: adddata.schooldisturl,
          county: adddata.county,
          institutetype: adddata.institutetype,
          schooltype: adddata.schooltype,
          instructionlevel: adddata.instructionlevel,
          lat: adddata.lat,
          lang: adddata.lang,
          schoolgrade: adddata.schoolgrade,
          latlangs: adddata.latlangs,
          school_cords: adddata.school_cords,
          rating: adddata.rating,
          rating_num: adddata.rating_num,
          gradelow: adddata.gradelow,
          gradehigh: adddata.gradehigh,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Update Function

async function updateSchool(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLUpdateSchool,

        variables: {
          id: updatedata.id,
          name: updatedata.name,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Delete Function

async function deleteSchool(deletedataId) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLDeleteSchool,
        variables: {
          id: deletedataId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//Get list by own query
async function getAllSchoolList(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getAllSchoolList,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
          zoomLevel: getdata.zoomLevel,
          device: getdata.device,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//////////////////////////////////////////////FUNCTION SECTION WRAP////////////////////////////////////////////////////

export { addSchool, updateSchool, deleteSchool, getAllSchoolList };
